import { Divider, makeStyles, Typography } from "@material-ui/core";

interface IInfoWindow {
  data: any;
  isSchool: boolean;
}

const InfoWindow = ({ data, isSchool }: IInfoWindow) => {
  const useStyles = makeStyles({
    infoWindowWrapper: {
      position: "relative",
      bottom: 90,
      left: "30px",
      width: 220,
      backgroundColor: "white",
      color: "black",
      boxShadow: "0 2px 7px 1px rgba(0, 0, 0, 0.3)",
      padding: 10,
      fontSize: 14,
      zIndex: 100,
    },
    divider: { marginBottom: 10 },
    textBold: { fontWeight: 600 },
  });

  const classes = useStyles();

  return (
    <div className={classes.infoWindowWrapper}>
      <Typography variant="subtitle2" gutterBottom>
        {isSchool ? data.name : data.address}
      </Typography>

      {!isSchool && (
        <>
          <Divider className={classes.divider} />
          <Typography variant="body2" gutterBottom>
            Number of Student: {data.passengers.length}
          </Typography>

          <Typography variant="body2" className={classes.textBold}>
            Student List
          </Typography>
          {data.passengers.map((passenger: any, index: number) => {
            return (
              <Typography
                variant="body2"
                gutterBottom={
                  data.passengers.length - 1 === index ? true : false
                }
              >
                - {passenger.student.firstName} {passenger.student.lastName}
              </Typography>
            );
          })}
        </>
      )}
    </div>
  );
};

export default InfoWindow;
